/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
export default {
    appendNew,
    resetState
}

function appendNew (state,notifications){
    if(!_.find(state.notifications,{NOTIFICATION_ID:notifications[0].NOTIFICATION_ID})){
        state.notifications = [...notifications,...state.notifications]
    }
}

function resetState (state) {
    // _.each(state, (value, key) => {
    //     state[key] = initialState[key]
    // })
    state = { ...initialState }
}
